import { Button } from '@rocco/components/button';
import { ReactComponent as EnquiryIcon } from '@rocco/icons/svg/message.svg';
import { BASE_STYLE } from './style';
import type { ProfessionalMessageProps } from './types';
import { capitalize } from './utils';
import { useEnquiryModal } from '~/modules-rocco/enquiry/hooks/use-enquiry-modal';
import { createEnquiryProfessional } from './utils';
import { ReactComponent as ShareIcon } from '@rocco/icons/svg/arrow/arrow-x.svg';

interface ActionButtonsProps {
    name: string;
    summary: boolean;
    professionalProps: ProfessionalMessageProps;
    category: string;
    iconType?: 'message' | 'share';
}

export const ActionButtons = ({
    name,
    professionalProps,
    category,
    summary,
    iconType = 'message',
}: ActionButtonsProps) => {
    let categoryName = capitalize(category);

    // Handle special case for 'Interiordesigners' (two words)
    if (categoryName === 'Interiordesigners') {
        categoryName = 'Interior Designer';
    } else {
        // Remove trailing 's' for most categories
        categoryName = categoryName.endsWith('s')
            ? categoryName.slice(0, -1)
            : categoryName;
    }

    const { openEnquiryModal } = useEnquiryModal({
        professional: createEnquiryProfessional(professionalProps),
        title: name,
        itemType: 'professional',
        siteTreeID: professionalProps.ProjectID,
        source: 'ProjectTeam',
        projectID: professionalProps.ProjectID,
        ctaLabel: professionalProps.CtaLabel,
    });

    return (
        <div
            className={`flex ${BASE_STYLE.GAP_STANDARD} w-full opacity-100 ${BASE_STYLE.BOTTOM_MARGIN}`}
            style={
                summary
                    ? BASE_STYLE.INLINE_STYLES.FADE_IN_SLOWER
                    : BASE_STYLE.INLINE_STYLES.FADE_IN_SLOW
            }
        >
            <Button
                type="button"
                color="dark"
                onClick={() => openEnquiryModal()}
            >
                <span
                    className={`flex items-center ${BASE_STYLE.GAP_STANDARD}`}
                >
                    Message {categoryName}
                    {iconType === 'message' ? (
                        <EnquiryIcon
                            aria-label={`Message ${name}`}
                            className="w-4 fill-white"
                        />
                    ) : (
                        <ShareIcon
                            aria-label={`Share ${name}`}
                            className="w-4 fill-white"
                        />
                    )}
                </span>
            </Button>
        </div>
    );
};
